import { constants, typographyStyles } from "@newsela/angelou";

const { textS } = typographyStyles;

const uiColors = constants.colors.ui;

export const commentOverlay = {
  alignItems: "center",
  backgroundColor: uiColors.neutral[100],
  borderRadius: "3px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  opacity: ".95",
  position: "absolute",
  minHeight: "80px",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
};

export const textCss = [
  {
    fontWeight: "bold",
    margin: "0 0 6px 0",
  },
  textS,
];
